import React, { useCallback, useRef, useState } from 'react';
import axios from '../../../sagas/axios';
import ModalAlert from '../../../components/modal/modal_alert';
import ModalLoader from '../../../../modal/modal_loader';

const Edit = ({
  violationReport,
  circle,
  violationTypes,
  isApp,
}) => {
  const [option, setOption] = useState(0);
  const [body, setBody] = useState('');
  const [images, setImages] = useState([]);
  const [focused, setFocused] = useState(false);
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onChangeImageData = useCallback(
    (imageFile) => {
      let formData = new FormData();
      formData.append('file', imageFile);
      formData.append('violation_report_id', violationReport.id);
      axios
        .patch(`/api/violation_reports/upload_image`, formData)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            setImages(response.data);
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [loaderRef, errorRef, violationReport, circle]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const data = JSON.stringify({
        violation_report_id: violationReport.id,
        option: option,
        body: body,
        circle_id: circle.id,
      });
      axios
        .post(`/api/violation_reports/circles/${circle.id}`, data)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      body,
      option,
      circle,
      violationReport,
    ]
  );

  const toCirclePage = useCallback(() => {
    window && (window.location.href = `/circle/${circle.id}`);
  });

  const violationTypesSelect = violationTypes.map((violationType) => {
    return (
      <option value={violationType.id} key={violationType.id}>
        {violationType.option_wording}
      </option>
    );
  });

  const changeOption = (e) => {
    setOption(e.target.value);
  };

  const onClickImage = () => {
    $('#CreateImage').click();
  }

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="bg-white h-100 pt-3 min-vh-100"
      >

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-24px text-black-333 text-fw-bold mb-0 mt-2 d-inline-block">
            「{circle.name}」サークルを通報する
          </p>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-16px text-black-333 mb-0 mt-4 d-inline-block">
            通報者の個人情報はお相手に通知されません。
          </p>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-16px text-black-333 mb-0 mt-4 d-inline-block">
            通報理由
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <select
                className="p-1 w-100 form-control text-gray"
                value={option}
              onChange={changeOption}
            >
              <option value={0} key={0}>
                選択してください
              </option>
              {violationTypesSelect}
            </select>
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-16px text-black-333 mb-0 mt-2 d-inline-block">
            通報理由の詳細（50文字以上）
          </p>
          <p className="text-fz-11px text-gray mb-0 mt-2 d-inline-block">
          ※理由は「いつ、どこで、だれに、何をされたことで通報しているのか」が伝わり、通報の真偽が客観的にわかるように記載してください。
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
          <textarea
              id="body"
              className="p-1 w-100 form-control text-gray"
              onBlur={() => {
                setFocused(false);
              }}
              onFocus={() => setFocused(true)}
              value={
                !focused && body.length == 0
                  ? '2023年1月14日開催の〇〇イベントに参加した際に、〇〇さんと連絡先を交換しました。\n\nその後に食事に行く約束をして後日お会いしたのですが、その際に2時間3000円のセミナーの勧誘を受けました。\n\nスクショ1枚目はセミナーに誘われた時のメッセージです。\n2枚目は・・・'
                  : body
              }
              onChange={(e) => setBody(e.target.value)}
              rows="12"
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-16px text-black-333 mb-0 mt-2 d-inline-block">
            通報理由の根拠となる画像（任意）
          </p>
          <p className="text-fz-11px text-gray mb-0 mt-2">
            例）外部SNSへの誘導や不快、暴力的、侮辱的な投稿、その他悪質な文言のスクリーンショットなど。
          </p>
          <p className="text-fz-11px text-gray mb-2 mt-2">
            ※画像は通報の判断のみに利用いたします。
          </p>
        </div>

        <div className="mb-0 bg-white">
          <div className="container col-md-8 col-lg-6">
            <div className="row flex-nowrap overflow-auto">
              {images.map((image) => {
                if (image.image_url_medium != undefined) {
                  return (
                    <div
                      key={`imageImages_${image.id}`}
                      className="col-3 col-md-2 col-lg-2 bg-gray m-2 position-relative p-0 adjust-box adjust-box-1x1"
                      style={{ height: 90 }}
                    >
                      <img
                        className="w-100 object-fit-cover adjust-box-inner"
                        type="image"
                        id={image.id}
                        src={image.image_url_medium}
                      />
                    </div>
                  );
                }
              })
            }
            {[...Array(10 - images.length)].map((_, i) => {
              return (
                <a
                  key={`ImageBox_${i + 1 + images.length}`}
                  className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
                  style={{ height: 90 }}
                  onClick={onClickImage}
                >
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(e) => {
                      onChangeImageData(e.target.files[0]);
                    }}
                    name="CreateImage"
                    id="CreateImage"
                    style={{ display: 'none' }}
                  />
                  <div className="w-100 object-fit-cover adjust-box-inner d-flex justify-content-end">
                    <p className="bg-secondary text-white position-absolute top-0 pl-2 pr-2">
                      {i + 1 + images.length}
                    </p>
                  </div>
                </a>
              );
            })}
            </div>
          </div>
        </div>

        <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
          <div
            className="container d-flex justify-content-around mt-3"
            style={{ marginBottom: isApp ? '24px' : '' }}
          >
            <button
              type="button"
              className={`a-button a-button__top a-button--orange mr-2 w-100 ${
                isApp == false ? 'mb-2' : ''
              }`}
              onClick={(e) => onSubmit(e)}
              disabled={option === 0 || body.length < 50}
            >
              送信する
            </button>
          </div>
        </div>

      </main>

      <ModalAlert
        ref={successRef}
        name="通報完了"
        content="通報に成功しました。"
        approveFunc={toCirclePage}
      />
      <ModalAlert
        ref={errorRef}
        name="通報失敗"
        content="通報に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
